import React from 'react'
import "bootstrap-icons/font/bootstrap-icons.css";

import SimpleProcess from './SimpleProcess'
import EligibilitySlider from './EligibilitySlider'
import LoanCalculator from './LoanCalculator'

const whyChoose = [
  { icon: "bi-percent", text: "Attractive Interest Rates on Card Loans" },
  { icon: "bi-lightning-charge", text: "Instant Approval on Existing Credit Cards" },
  { icon: "bi-file-earmark-check", text: "No Additional Documentation Required" },
  { icon: "bi-clock", text: "Quick Processing & Instant Disbursal" },
  { icon: "bi-cash-stack", text: "Loan Amount Based on Card Limit" },
  { icon: "bi-headset", text: "Dedicated Customer Support" },
];

const loanFeatures = [
  { icon: "bi-credit-card", text: "Pre-Approved Offers on Select Credit Cards" },
  { icon: "bi-currency-rupee", text: "Loan Amount: Based on available credit limit" },
  { icon: "bi-clock-history", text: "Flexible Tenure: 3 to 48 months" },
  { icon: "bi-arrow-repeat", text: "Easy EMI Conversion Option" },
  { icon: "bi-shield-check", text: "Transparent Charges & Processing" },
];

const CreditCardLoan = () => {
  return (
    <div>

      {/* Hero Section */}
      <section className="welcome_area creditcard" id="home">
        <div className="container">
          <div className="row align-items-center">

            <div className="col-12 col-lg-6 col-md-12">
              <div className="welcome-content">

                <div className="promo-section">
                  <div className="integration-link">
                    <div className="integration-icon">
                      <p className="badge">Loan on Credit Card</p>
                    </div>
                    <span className="integration-text">
                      Instant Funds Without Extra Paperwork
                    </span>
                  </div>
                </div>

                <h1 className="b-text bold">
                  Get Quick Cash Against Your Credit Card with Me Loans
                </h1>

                <p>
                  Need urgent funds? Convert your available credit limit into 
                  easy EMIs with Me Loans. Enjoy instant approval, flexible 
                  tenure, and hassle-free processing.
                </p>

                <div className="dream-btn-group fadeInUp" data-wow-delay="0.4s">
                  <a href="/contact" className="btn more-btn mr-3">
                    Contact Us
                  </a>
                  <a className="btn more-btn" href="/apply-for-loan">
                    Apply For Loan
                  </a>
                </div>

              </div>
            </div>

            <div className="col-lg-6"></div>

          </div>
        </div>
      </section>


      {/* About Section */}
      <section className="about-us-area section-padding-100 clearfix">
        <div className="container-fluid">
          <div className="row align-items-center">

            <div className="col-12 col-lg-6 offset-lg-0 col-md-12 no-padding-left">
              <div className="welcome-meter fadeInUp" data-wow-delay="0.7s">
                <img draggable="false" src="image/credit.png" alt="Credit Card Loan" />
              </div>
            </div>

            <div className="col-12 col-lg-6 offset-lg-0 col-md-10 offset-md-1">
              <div className="who-we-contant mt-s">

                <h4 className="fadeInUp" data-wow-delay="0.3s">
                  Why Choose Me Loans for Loan on Credit Card?
                </h4>

                <p className="fadeInUp" data-wow-delay="0.4s">
                  Me Loans provides quick and convenient access to funds 
                  through your existing credit card. With minimal processing 
                  and no additional paperwork, you can get instant liquidity.
                </p>

                <p className="fadeInUp" data-wow-delay="0.5s">
                  Convert your available credit limit into affordable EMIs 
                  with flexible tenure options and transparent charges.
                </p>

                <a
                  className="btn more-btn mt-30 fadeInUp"
                  data-wow-delay="0.6s"
                  href="/apply-for-loan"
                >
                  Apply For Loan
                </a>

              </div>
            </div>

          </div>
        </div>
      </section>


      {/* Why Choose & Loan Features */}
      <section className="py-5 bg-light">
        <div className="container">

          <div className="text-center mb-5">
            <h2 className="fw-bold">
              Why Choose Me Loans for Loan on Credit Card?
            </h2>
          </div>

          <div className="row g-4 mb-5">
            {whyChoose.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="feature-box shadow-sm p-4 bg-white rounded h-100 d-flex align-items-center">
                  <i className={`bi ${item.icon} feature-icon me-3`}></i>
                  <h6 className="mb-0">{item.text}</h6>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mb-4">
            <h3 className="fw-bold text-secondary">Loan Features</h3>
          </div>

          <div className="row g-4">
            {loanFeatures.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="feature-box shadow-sm p-4 bg-white rounded h-100 d-flex align-items-center">
                  <i className={`bi ${item.icon} feature-icon me-3`}></i>
                  <h6 className="mb-0">{item.text}</h6>
                </div>
              </div>
            ))}
          </div>

        </div>

        <style>{`
          .feature-box {
            transition: 0.3s ease;
          }

          .feature-box:hover {
            transform: translateY(-6px);
          }

          .col-md-6.col-lg-4 {
            padding: 6px;
          }

          .feature-icon {
            font-size: 28px;
            color: #1fa5a9;
          }
        `}</style>

      </section>

      <SimpleProcess />
      <LoanCalculator />
      <EligibilitySlider />

    </div>
  )
}

export default CreditCardLoan